import React from 'react';
import {Dropdown, Input} from 'semantic-ui-react';
import {WARRANTIES_TYPES} from '../../../warranties/constants';

export const Filter = ({column}) => {
  return <div>{column.canFilter && column.render('Filter')}</div>;
};

export const DefaultColumnFilter = ({'column': {filterValue, setFilter}}) => {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || null);
      }}
    />
  );
};

export const SelectColumnFilter = ({
  'column': {filterValue, setFilter, id},
}) => {
  return (
    <Dropdown
      className='filter-selection'
      selection
      defaultValue='TODOS'
      value={filterValue}
      options={WARRANTIES_TYPES}
      onChange={(e, {value}) => {
        const currentValue = value !== 'TODOS' ? value : null;
        setFilter(currentValue);
      }}
    />
  );
};

